import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "cart-section desktop-only" }
const _hoisted_5 = {
  key: 0,
  class: "bet-count"
}
const _hoisted_6 = { class: "mobile-actions mobile-only" }
const _hoisted_7 = {
  key: 0,
  class: "bet-count"
}

import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import { useBetslipStore } from '../../stores/betslip'
import { useModalStore } from '../../stores/modal'
import { useTheme } from '../../composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute()
const authStore = useAuthStore()
const betslipStore = useBetslipStore()
const modalStore = useModalStore()
const { currentTheme } = useTheme()

const betCount = computed(() => betslipStore.betslip?.length || 0)

const isActive = (path: string) => route.path === path

const openBetslip = () => {
  modalStore.openBetslip()
}

const showWagers = computed(() => {
  const hideWhenUnauthenticated = currentTheme.value?.navigation?.hideWagersWhenUnauthenticated
  if (hideWhenUnauthenticated) {
    return authStore.isAuthenticated || authStore.hasValidSession()
  }
  return true
})

onMounted(() => {
  authStore.initializeFromSession()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/all",
          class: _normalizeClass(["nav-link", { active: isActive('/all') }])
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("All")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/next-draws",
          class: _normalizeClass(["nav-link", { active: isActive('/next-draws') }])
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Next Draws")
          ])),
          _: 1
        }, 8, ["class"]),
        (showWagers.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/wagers",
              class: _normalizeClass(["nav-link", { active: isActive('/wagers') }])
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Wagers")
              ])),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/results",
          class: _normalizeClass(["nav-link", { active: isActive('/results') }])
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Results")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/how-to-play",
          class: _normalizeClass(["nav-link", { active: isActive('/how-to-play') }])
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("How to Play")
          ])),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "cart-icon",
          onClick: openBetslip
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: "/img/icons/cart.svg",
            alt: "Cart",
            class: "cart-svg"
          }, null, -1)),
          (betCount.value > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(betCount.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "cart-icon",
          onClick: openBetslip
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: "/img/icons/cart.svg",
            alt: "Cart",
            class: "cart-svg"
          }, null, -1)),
          (betCount.value > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(betCount.value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})